import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AiService } from '../../../../service/ai.service';

@Component({
  selector: 'app-result-preview',
  standalone: false,
  templateUrl: './result-preview.component.html',
  styleUrl: './result-preview.component.scss'
})
export class ResultPreviewComponent {
  isEditing: boolean = false;
  isLoading: boolean = false;
  form: any;
  backupData: any;

  // mat dialog output, export/download button weg und close wird zu cancel => cancel emited auch aber leer

  @Output() dataChanged = new EventEmitter<any>();

  constructor(
    private aiService: AiService,
    private dialogRef: MatDialogRef<ResultPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // duplicate data to backupdata
    this.backupData = { ...this.data };
    this.form = this.buildForm(this.data);
    // console.log('ResultPreviewComponent initialized with data:', this.data);

  }

  async miroExport() {
    this.isLoading = true;
    await this.aiService.aiMiroExport(this.data)
    this.isLoading = false;
  }

  buildForm(data: any): FormGroup | FormArray | FormControl {
    if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean') {
      return new FormControl(data);
    } else if (Array.isArray(data)) {
      const controls = data.map((item: any) => this.buildForm(item));
      return new FormArray(controls);
    } else if (typeof data === "object" && data !== null) {
      const group: { [key: string]: any } = {};
      for (const key of Object.keys(data)) {
        group[key] = this.buildForm(data[key]);
      }
      return new FormGroup(group);
    }
    return new FormControl(null);
  }

  close() {
    if (this.isEditing) {
      // CANCEL after Editing was opend
      this.isEditing = false;
      this.data = { ...this.backupData };
      this.form = this.buildForm(this.data);
    } else {
      // Closing when not editing Mode
      this.dialogRef.close({ type: "close", resultData: this.data })
    }
  }



  toggleEdit() {
    if (this.isEditing) {
      // Save after Editing Mode
      this.data = this.form.value;
      this.backupData = { ...this.data };
      this.form = this.buildForm(this.data);

      this.isEditing = false;
    } else {
      // Open editing Mode
      this.isEditing = true;
    }

  }

  downloadAsPdf() {
    this.dialogRef.close({ type: "download-pdf", resultData: this.data })
  }


  originalOrder = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
    return 0;
  }

  keyToHeading(key: any) {
    return key.split('_').map((word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
  }

  isNumber(value: any): value is number {
    return typeof value === "number";
  }

  isString(value: any): value is string {
    return typeof value === "string";
  }

  isArray(value: any): value is any[] {
    return Array.isArray(value);
  }

  isObject(value: any): value is Record<string, any> {
    return typeof value === "object" && value !== null && !Array.isArray(value);
  }

  isFormGroup(control: any): control is FormGroup {
    return control instanceof FormGroup;
  }

  isFormArray(control: any): control is FormArray {
    return control instanceof FormArray;
  }

  isFormControl(control: any): control is FormControl {
    return control instanceof FormControl;
  }

}
